import React from 'react';
import { C, BODY, MONO, FadeUp, Kicker, SectionH2, SECTION_PAD, useSectionView } from './shared';

const LEFT = ['Same advice for every business', 'No memory of your goals', 'No live competitor data', 'Generic robotic voice', 'You must know what to ask', 'Starts from zero every session'];
const RIGHT = ['Built around your specific business', 'Remembers everything, gets sharper over time', 'Analyzes competitors using live website data', 'Writes in your voice automatically', 'Tells you what to do before you ask', 'Built for founders, not power users'];

export const ComparisonSection = () => {
  const ref = useSectionView('comparison');
  return (
    <section id="why" ref={ref} style={{ padding: SECTION_PAD, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <FadeUp><Kicker>Why ScalitOS</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2>
            Blank tools wait for questions.<br />
            <span style={{ color: C.lime }}>ScalitOS brings answers.</span>
          </SectionH2>
        </FadeUp>

        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))', gap: 18 }}>
          <FadeUp delay={120}>
            <div style={{ padding: 28, border: `1px solid ${C.border}`, borderRadius: 16, background: 'rgba(255,255,255,0.012)', height: '100%' }}>
              <p style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '0.22em', color: C.muted, textTransform: 'uppercase', marginBottom: 22 }}>Scattered tools</p>
              {LEFT.map((it, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
                  <span aria-hidden="true" style={{ color: '#e07070', fontFamily: MONO, fontSize: 13, marginTop: 2 }}>&#10005;</span>
                  <p style={{ fontFamily: BODY, fontSize: 14.5, color: C.body, lineHeight: 1.6 }}>{it}</p>
                </div>
              ))}
            </div>
          </FadeUp>
          <FadeUp delay={220}>
            <div style={{ position: 'relative', padding: 28, border: `1px solid ${C.borderLime}`, borderRadius: 16, background: 'linear-gradient(180deg, rgba(200,241,53,0.06), rgba(200,241,53,0.015))', height: '100%', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 24, right: 24, height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,241,53,0.5), transparent)' }} />
              <p style={{ fontFamily: MONO, fontSize: 10.5, letterSpacing: '0.22em', color: C.lime, textTransform: 'uppercase', marginBottom: 22 }}>ScalitOS</p>
              {RIGHT.map((it, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 14 }}>
                  <span aria-hidden="true" style={{ color: C.lime, fontFamily: MONO, fontSize: 13, marginTop: 2 }}>&#10003;</span>
                  <p style={{ fontFamily: BODY, fontSize: 14.5, color: C.text, lineHeight: 1.6 }}>{it}</p>
                </div>
              ))}
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
